import {
  AssessmentButton,
  InputField,
  SearchTypeSelect,
  showToast,
} from "ui-components";
import "./AddressField.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import useDebounce from "../../../../../utils/Hooks/useDebounce";
import {
  getCountry,
  getState,
} from "../../../../../service/CvScanning/CvScanning";
import usePlacesAutocomplete from "../../../../../utils/Hooks/usePlacesAutocomplete";
import AutoCompleteSearch from "../../../../../components/GoogleLocationComponents/AutoCompleteSearch/AutoCompleteSearch";
import MapComponent from "../../../../../components/GoogleLocationComponents/MapComponent/MapComponent";
import {
  getLocationComponents,
  removeFromQueryParams,
} from "../../../../../utils/Common/Constant";
import useCurrentLocation from "../../../../../utils/Hooks/useCurrentLocation";
import { useNavigate } from "react-router-dom";
const AddressField = ({
  addressField,
  handleAddressField,
  setLocationPopupOpen,
  setEditAddressDetails,
}: any) => {
  const { t } = useTranslation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const defaultSelectCountry = { value: "", label: "" };
  const defaultSelectState = { value: "", label: "" };
  const [getCountryList, setGetCountryList] = useState<any>([]);
  const [getStateList, setGetStateList] = useState<any>([]);
  const [skillIdFromCountry, setSkillIdFromCountry] = useState<any>(
    addressField?.country || defaultSelectCountry,
  );
  const [skillIdFromState, setSkillIdFromState] = useState<any>(
    addressField?.state || defaultSelectState,
  );
  const debounceCountrySearchValue = useDebounce(
    skillIdFromCountry?.label?.trim(),
    400,
  );
  const debounceStateSearchValue = useDebounce(
    skillIdFromState?.label?.trim(),
    400,
  );
  const setInCompleteLocation = (key: string, value: any) => {
    setCompleteLocation((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };
  async function getCountryData(country?: any, state?: any) {
    if (country || state) {
      const countryRes = await getCountry(country);
      if (countryRes?.status) {
        const filterCountryData = countryRes?.data?.data.map((item: any) => {
          return { label: item?.name, value: item?.countryId };
        });
        if (filterCountryData?.length) {
          if (filterCountryData[0]?.value) {
            const stateRes = await getState(filterCountryData[0]?.value, state);
            const filterStateData = stateRes?.data?.data?.map((item: any) => {
              return { label: item?.name, value: item?.stateId };
            });
            setGetStateList(filterStateData);
            setSkillIdFromState({
              value: filterStateData[0]?.value || "",
              label: filterStateData[0]?.label || "",
            });
            setInCompleteLocation("state", {
              value: filterStateData[0]?.value || "",
              label: filterStateData[0]?.label || "",
            });
          }

          setGetCountryList(filterCountryData);
          setSkillIdFromCountry({
            value: filterCountryData[0]?.value,
            label: filterCountryData[0]?.label,
          });
          setInCompleteLocation("country", {
            value: filterCountryData[0]?.value,
            label: filterCountryData[0]?.label,
          });
        } else {
          setSkillIdFromCountry({
            value: "",
            label: "",
          });
          setInCompleteLocation("country", {
            value: "",
            label: "",
          });
          setSkillIdFromState({
            value: "",
            label: "",
          });
          setInCompleteLocation("state", {
            value: "",
            label: "",
          });
        }
      }
    } else {
      const countryRes = await getCountry(debounceCountrySearchValue);
      if (countryRes?.status) {
        const filterCountryData = countryRes?.data?.data.map((item: any) => {
          return { label: item?.name, value: item?.countryId };
        });
        if (skillIdFromCountry?.value) {
          const stateRes = await getState(
            skillIdFromCountry?.value,
            debounceStateSearchValue,
          );
          const filterStateData = stateRes?.data?.data?.map((item: any) => {
            return { label: item?.name, value: item?.stateId };
          });
          setGetStateList(filterStateData);
        }
        setGetCountryList(filterCountryData);
        return filterCountryData;
      }
    }
  }
  useEffect(() => {
    if (!skillIdFromCountry?.label) {
      setSkillIdFromState(defaultSelectState);
    }
  }, [skillIdFromCountry]);
  const onCrossPress = () => {
    setGetCountryList([]);
    setGetStateList([]);
    setSkillIdFromCountry(defaultSelectCountry);
    setSkillIdFromState(defaultSelectState);
  };
  useEffect(() => {
    // to get skills
    getCountryData();
  }, [debounceCountrySearchValue, debounceStateSearchValue]);
  const {
    inputValue,
    setInputValue,
    suggestions,
    loading,
    error,
    selectedPlace,
    handleSelectPlace,
    setSuggestions,
    setSelectedPlace,
  } = usePlacesAutocomplete();
  const [placeSelected, setPlaceSelected] = useState(false);
  const [center, setCenter] = useState<any>(addressField?.coordinates ?? null);
  const locationData: any = useCurrentLocation();
  const { coords } = locationData;
  const [currentCoords, setCurrentCoords] = useState<any>(null);
  const [completeLocation, setCompleteLocation] = useState<any>({
    addressLine1: addressField?.addressLine1 ?? "",
    addressLine2: addressField?.addressLine2 ?? "",
    country: addressField?.country ?? { label: "", value: "" },
    state: addressField?.state ?? { label: "", value: "" },
    city: addressField?.city ?? "",
    zipcode: addressField?.zipcode ?? "",
    coordinates: addressField?.coordinates ?? null,
    id: addressField?.id ?? "",
  });
  useEffect(() => {
    if (!center) {
      setCurrentCoords(coords);
    }
  }, [coords]);
  useEffect(() => {
    const newCenter = selectedPlace?.location;
    if (newCenter?.latitude && newCenter?.longitude) {
      setCurrentCoords(null);
      setCenter(newCenter);
      setInCompleteLocation("coordinates", newCenter);
    }
  }, [selectedPlace]);
  const onPlaceSelected = () => {
    const country =
      getLocationComponents(selectedPlace?.addressComponents, "country") || "";
    const state =
      getLocationComponents(
        selectedPlace?.addressComponents,
        "administrative_area_level_1",
      ) || "";
    const city =
      getLocationComponents(selectedPlace?.addressComponents, "locality") || "";
    const zipcode =
      getLocationComponents(selectedPlace?.addressComponents, "postal_code") ||
      "";
    const searchedAddress = selectedPlace?.formattedAddress;
    if (country || state || city || zipcode || searchedAddress) {
      if (country || state) {
        getCountryData(country, state);
      }
      setInCompleteLocation("city", city);
      setInCompleteLocation("zipcode", zipcode);
      setInCompleteLocation("addressLine1", searchedAddress);
    }
  };
  useEffect(() => {
    if (selectedPlace) {
      const countryTitle = getLocationComponents(
        selectedPlace?.addressComponents,
        "country",
      );
      if (countryTitle !== "India" && countryTitle !== "United States") {
        showToast(t("GENERAL.OPERATE_INDIA_USA"));
      } else {
        onPlaceSelected();
      }
    }
  }, [selectedPlace]);
  const handleLocationSave = () => {
    const validateField = () => {
      switch (true) {
        case !completeLocation.addressLine1:
          showToast(t("ERROR.ADDRESS_REQUIRED"), "error");
          return false;

        case !skillIdFromCountry.value || !skillIdFromCountry.label:
          showToast(t("ERROR.COUNTRY_REQUIRED"), "error");
          return false;

        case !skillIdFromState.value || !skillIdFromState.label:
          showToast(t("ERROR.STATE_REQUIRED"), "error");
          return false;

        case !completeLocation.city:
          showToast(t("ERROR.CITY_REQUIRED"), "error");
          return false;

        case !completeLocation.zipcode:
          showToast(t("ERROR.ZIPCODE_REQUIRED"), "error");
          return false;

        default:
          return true;
      }
    };
    if (!validateField()) return;
    setCompleteLocation({
      addressLine1: "",
      addressLine2: "",
      country: "",
      state: "",
      city: "",
      zipcode: "",
      coordinates: null,
    });
    setSkillIdFromCountry({
      value: "",
      label: "",
    });
    setSkillIdFromState({
      value: "",
      label: "",
    });
    setInputValue("");
    handleAddressField(completeLocation);
    setLocationPopupOpen(false);
    removeFromQueryParams(queryParams, "lp", navigate);
    setEditAddressDetails(null);
  };
  return (
    <>
      <div className="addressFieldForm row jobModuleStyle">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="addressSearch mb-3">
            <AutoCompleteSearch
              inputValue={inputValue}
              setInputValue={setInputValue}
              suggestions={suggestions}
              loading={loading}
              error={error}
              selectedPlace={selectedPlace}
              handleSelectPlace={handleSelectPlace}
              setSuggestions={setSuggestions}
              setSelectedPlace={setSelectedPlace}
              placeSelected={placeSelected}
              setPlaceSelected={setPlaceSelected}
              onCrossPress={() => onCrossPress()}
            />
          </div>

          <div className="addressField">
            <div className="address-one field">
              <p>{t("RESUME.SCANNING_ADDRESS_1")}</p>
              <InputField
                value={completeLocation.addressLine1}
                onChange={(e: any) => {
                  setInCompleteLocation("addressLine1", e);
                }}
                placeholder={t("RESUME.SCANNING_ADDRESS_1")}
                additionalProps={{
                  className: "textInput",
                  name: "addressLine1",
                }}
              />
            </div>
            <div className="address-two field">
              <p>{t("RESUME.SCANNING_ADDRESS_2")}</p>
              <InputField
                value={completeLocation.addressLine2}
                onChange={(e: any) => {
                  setInCompleteLocation("addressLine2", e);
                }}
                placeholder={t("RESUME.SCANNING_ADDRESS_2")}
                additionalProps={{
                  className: "textInput",
                  name: "addressLine2",
                }}
              />
            </div>
          </div>
          <div className="countryField">
            <div className="country field">
              <p>{t("RESUME.SCANNING_COUNTRY")}</p>

              <SearchTypeSelect
                options={getCountryList}
                placeholder={t("RESUME.SCANNING_COUNTRY")}
                value={skillIdFromCountry}
                onChange={(getValue: any) => {
                  setSkillIdFromCountry(getValue);
                  setInCompleteLocation("country", {
                    label: getValue?.label,
                    value: getValue?.value,
                  });
                }}
                loadingText={t("GENERAL.LOADING")}
              />
            </div>
            <div className="state field">
              <p>{t("RESUME.SCANNING_STATE")}</p>
              <SearchTypeSelect
                options={getStateList}
                placeholder={t("RESUME.SCANNING_STATE")}
                value={skillIdFromState}
                onChange={(getValue: any) => {
                  setSkillIdFromState(getValue);
                  setInCompleteLocation("state", {
                    label: getValue?.label,
                    value: getValue?.value,
                  });
                }}
                loadingText={t("GENERAL.LOADING")}
              />
            </div>
            <div className="city field">
              <p>{t("RESUME.SCANNING_CITY")}</p>
              <InputField
                value={completeLocation.city}
                onChange={(e: any) => {
                  setInCompleteLocation("city", e);
                }}
                placeholder={t("RESUME.SCANNING_CITY")}
                additionalProps={{
                  className: "textInput",
                  name: "city",
                }}
              />
            </div>
            <div className="zipcode field">
              <p>{t("RESUME.ZIPCODE")}</p>
              <InputField
                value={completeLocation.zipcode}
                onChange={(e: any) => {
                  setInCompleteLocation("zipcode", e);
                }}
                placeholder={t("RESUME.ZIPCODE")}
                additionalProps={{
                  className: "textInput",
                  name: "zipcode",
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 d-flex align-items-center justify-content-center">
          {currentCoords || center ? (
            <MapComponent
              lat={currentCoords?.lat || center?.latitude}
              lng={currentCoords?.lng || center?.longitude}
            />
          ) : (
            <img
              src={require("../../../../../utils/Images/Map.png")}
              alt=""
              className="map-image"
            />
          )}
        </div>
        <div className="locationSaveBtn">
          <AssessmentButton onClick={handleLocationSave}>
            {t("GENERAL.SAVE")}
          </AssessmentButton>
        </div>
      </div>
    </>
  );
};

export default AddressField;
